import get from "lodash/get"
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import stringReplacer from "../functions/stringReplacer";
import useLocale from "@Hooks/selector/useLocale";
import {translationTestKeys} from "@Translation/constants/translationTestKeys";

/**
 * Returns translation from messages.yaml, optionally replaces parameters
 */
export function useTranslation(key: string, variableReplacements: object = {}, exact: boolean = false): any {
    const {checkorderUi} = useAppSelector((state) => (state?.page.experimentsJson))
    const translationTestLocales = ['en', 'hr']
    const locale = useLocale()

    if (checkorderUi && translationTestLocales.includes(locale) && translationTestKeys.includes(key)) {
        key = key.concat("_test")
    }

    const translation = useAppSelector((state) => get(state?.page.translations, key) ?? key)
    const entries = Object.entries(variableReplacements)
    const hasEntries = entries.length > 0

    if (hasEntries) {
        return stringReplacer(translation, variableReplacements, exact)
    }

    return translation
}